var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.AppState.isStandalone)?_c('div',{staticClass:"d-none d-sm-block sub-header-wrap"},[_c('b-button',{attrs:{"variant":"link","to":{name: 'notice'},"size":"sm"}},[_c('icon',{staticClass:"sh-icon",attrs:{"name":"exclamation-circle"}}),_c('span',[_vm._v(_vm._s(_vm.$t('notice')))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }